import { render, staticRenderFns } from "./AppButtonAddCustomer.vue?vue&type=template&id=62e58c84&scoped=true&"
import script from "./AppButtonAddCustomer.vue?vue&type=script&lang=ts&"
export * from "./AppButtonAddCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e58c84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
